module.exports = __webpack_public_path__ + "static/media/GSPORT LOGO.def12736.jpg";